import { Controller } from "@hotwired/stimulus"
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import DateTimePicker from '../../../frontend/components/DateTimePicker.vue'
import DateTimeRangePicker from '../../../frontend/components/DateTimeRangePicker.vue'
import InlineHelp from '../../../frontend/components/InlineHelp.vue'
import Multiselect from '../../../frontend/components/Multiselect.vue'
import PrivacyToggleSwitch from '../../../frontend/components/PrivacyToggleSwitch.vue'
import { i18n } from '../../../frontend/entrypoints/i18n'
import PrimeVue from 'primevue/config'

export default class extends Controller {
  connect() {
    this.app = createApp()
    this.app.component('datetimepicker', DateTimePicker)
    this.app.component('datetimerangepicker', DateTimeRangePicker)
    this.app.component('inlinehelp', InlineHelp)
    this.app.component('multiselect', Multiselect)
    this.app.component('privacytoggleswitch', PrivacyToggleSwitch)
    this.app.use(PrimeVue, { unstyled: true })
    this.app.use(i18n)
    this.app.mount(this.element)

    let controllers = this.element.dataset.controller.split(' ')
    controllers = controllers.filter(c => c !== 'extended-form-controls')
    this.element.dataset.controller = controllers.join(' ')
  }
}
